module.exports = __webpack_public_path__ + "img/videobgc3.1228ebbc.png";